module.exports = __webpack_public_path__ + "static/media/rf5.75cef530.jpeg";